import React from "react";
import { Paper, Box, Typography } from "@mui/material";
import { textPrimary, textSecondary } from "../constants/consts";

export default function AppStatTile({ icon: Icon, label, value, color }) {
  return (
    <Paper
      elevation={0}
      sx={{
        p: 2.25,
        borderRadius: 3,
        display: "flex",
        alignItems: "center",
        gap: 2,
        backgroundColor: "rgba(255,255,255,0.98)",
        boxShadow: "0 8px 24px rgba(15,50,65,0.14)",
        border: "1px solid rgba(255,255,255,0.6)",
        transition: "transform 0.2s ease, box-shadow 0.2s ease",
        "&:hover": {
          transform: "translateY(-2px)",
          boxShadow: "0 12px 28px rgba(15,50,65,0.2)",
        },
      }}
    >
      <Box
        sx={{
          width: 48,
          height: 48,
          borderRadius: 2,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          backgroundColor: `${color}14`,
          color,
          flexShrink: 0,
        }}
      >
        <Icon sx={{ fontSize: 24 }} />
      </Box>
      <Box sx={{ minWidth: 0, flex: 1 }}>
        <Typography
          variant="caption"
          sx={{
            color: textSecondary,
            fontWeight: 600,
            letterSpacing: "0.04em",
            textTransform: "uppercase",
            fontSize: 11,
          }}
          display="block"
        >
          {label}
        </Typography>
        <Typography
          variant="h5"
          fontWeight={600}
          color={textPrimary}
          sx={{ lineHeight: 1.2, mt: 0.25 }}
          noWrap
          title={value}
        >
          {value}
        </Typography>
      </Box>
    </Paper>
  );
}
